import { useMediaQuery } from '@mui/material';
import PasswordRecoveryAmplify from 'features/Authentication/PasswordRecovery';
import AuthLayout from 'layouts/AuthLayout';
import theme from 'themes';

const PasswordRecovery = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <AuthLayout title='Get Reset Link' isMobile={isMobile}>
      <PasswordRecoveryAmplify />
    </AuthLayout>
  );
};

export default PasswordRecovery;
